import { useQuery } from '@apollo/client';
import { graphql } from '@packages/charka-common-ui/graphql/types';

const QUERY = graphql(`
  query MenuSections($menuId: ID!) {
    menuSections(menuId: $menuId) {
      id
      code
      name
    }
  }
`);

export function useMenuSection(menuId: string) {
  return useQuery(QUERY, {
    variables: {
      menuId,
    },
  });
}
